export const TabsTestPageObject = (
    instances: readonly string[],
    onAddInstance: () => void,
    handleRemoveInstance: (instance: string) => void,
    handleSetPage: (instance: string | undefined) => void
) => ({
    getType: () => "Tabs",

    getInstancesCount: () => instances.length,

    setPage: (instance: string | undefined) => handleSetPage(instance),

    addInstance: () => onAddInstance(),

    deleteInstance: (instance: string) => handleRemoveInstance(instance),

    getInstances: () => instances,
});
